// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"216":"aa98c29e","339":"f5af14b3","614":"a6d24a88"}[chunkId] + ".chunk.js";
};